import {
  GET_ONLINE_COURSE_REQUEST,
  GET_ONLINE_COURSE_SUCCESS,
  GET_ONLINE_COURSE_FAILURE,
} from "../../actionTypes";

export const getOnlineCourseRequest = (type) => ({
  type: GET_ONLINE_COURSE_REQUEST,
  payload: type,
});

export const getOnlineCourseSuccess = (data) => ({
  type: GET_ONLINE_COURSE_SUCCESS,
  payload: data,
});

export const getOnlineCourseFailure = (error) => ({
  type: GET_ONLINE_COURSE_FAILURE,
  payload: error,
});
